import React from 'react'
import { NavLink as Link } from 'react-router-dom'

class HomeComponenteDestaque extends React.Component {
    render() {
        return <>{this.renderServico(this.props.conteudo)}</>
    }

    renderServico(conteudo) {
        if (conteudo) {
            switch (conteudo.tipo) {
                case 'serviço':
                    var backGroudStyle = {
                        backgroundImage: `url("data:image/jpeg;base64,${conteudo.imagemByte}")`,
                    }

                    return (
                        <div style={backGroudStyle} className="homeDestaqueImagemDeFundo homeDestaqueCardImagem">
                            <p className="homeDestaqueTitulo1">{conteudo.tituloSuperior}</p>

                            {conteudo.url && conteudo.url.includes('http') ? (
                                <a href={conteudo.url} target="blank" className="homeDestaqueTitulo2">
                                    {conteudo.tituloMenu}
                                </a>
                            ) : (
                                <Link className="homeDestaqueTitulo2" to={conteudo.url} title={conteudo.tituloMenu}>
                                    {conteudo.tituloMenu}
                                </Link>
                            )}
                        </div>
                    )

                case 'atalho':
                    return (
                        <div className="homeDestaqueImagemDeFundo">
                            <p className="homeDestaqueTitulo1">{conteudo.tituloSuperior}</p>
                            <a href={conteudo.url} target="blank">
                                {conteudo.tituloMenu}
                            </a>
                        </div>
                    )

                case 'conteudo':
                    let params = {
                        conteudo: conteudo.conteudo,
                        titulo: conteudo.tituloMenu,
                    }

                    var backGroudStyle = {
                        backgroundImage: `url("data:image/jpeg;base64,${conteudo.imagemByte}")`,
                    }

                    return (
                        <div style={backGroudStyle} className="homeDestaqueImagemDeFundo homeDestaqueCardImagem">
                            <p className="homeDestaqueTitulo1">{conteudo.tituloSuperior}</p>
                            <p className="homeDestaqueTitulo2">{conteudo.tituloMenu}</p>
                            <div className="containerBotaoAreaDestaque">
                                <Link
                                    className="botaoAreaDestaque"
                                    to={'/conteudoGrupo/' + btoa(encodeURIComponent(JSON.stringify(params)))}
                                    title={conteudo.tituloMenu}
                                >
                                    ACESSE
                                </Link>
                            </div>
                        </div>
                    )

                default:
                    return <div className="homeDestaqueImagemDeFundo">{conteudo.tituloMenu} </div>
            }
        }
    }
}

export default HomeComponenteDestaque
